export default __webpack_public_path__ + "static/media/icone_ambiente_seguro.4672c7c6.svg";